module.exports={
    btn:{
        tips_reelect_btn:"Новое изображение",
        cancel_btn:"Отмена",
        tips_continue_dispose:"Высококачественные поддерживаемые изображения",
        tips_return:"Новое изображение",
        tips_upgrade:"Обновление",
        tips_yes:"ХОРОШО",
        delete:"Удалить",
        download:"Скачать",
        upload_image:"Загрузить изображение",
        new_image:"Новое изображение",
        save_all:"Сохранить все",
        cancel:"Отмена",
        save:"Сохранять",
        view_comparison:"Посмотреть сравнение",
        hide_comparison:"Скрыть сравнение",
        previous:"Предыдущий",
        next:"Следующий",
        continue_download:"Сохраняйте изображения с водяными знаками",
        present:"Применить к этому изображению",
        all_wait:"Применить к изображениям в ожидании",
        all:"Применить ко всем изображениям",
        history:"История",
        login:"Авторизоваться",
    },
    tips:{
        please_upgrade:"Ваш текущий план не поддерживает пакетную загрузку или масштабирование изображений. Пожалуйста, обновите его, чтобы получить больше преимуществ.",
        errorlistinfo:"Выбрано XXX изображений. Изображения XXX поддерживаются, но изображения XXX не поддерживаются. Следующие изображения не поддерживаются:",
        max:"Превышайте максимальный размер изображения в 10 МБ!",
        max_size:"Превышение максимальной длины стороны изображения в 4096 пикселей!",
        continue_dispose:"Высококачественные поддерживаемые изображения",
        please_multiple:"Пожалуйста, выберите увеличение.",
        max_multiple:"* Ваше изображение будет увеличено не более чем до 4K (самая длинная сторона не будет превышать 4096 пикселей).",
        title:"Имя",
        reasons:"Причины",
        upload_type:"Не поддерживается",
        used_up:"Количество сохраненных HD-изображений без водяных знаков исчерпано. Пожалуйста, обновите свой аккаунт. Или вы можете сохранять HD-изображения с водяными знаками.",
        edit_multiple:"Загружено несколько изображений. Пожалуйста, выберите изображения, масштаб которых вы хотите изменить. После выбора эти изображения будут снова увеличены до нового увеличения.",
        download_confirm:"Некоторые изображения еще обрабатываются. Вы уверены, что сохранили все увеличенные изображения? При многократном сохранении одного и того же изображения количество сохраняемых изображений больше не будет вычтено.",
        waiting_save:"Некоторые изображения еще обрабатываются. Пожалуйста, сохраните позже.",
        
    },
    header:{
        title:"AnyMP4 Image Upscaler онлайн",
        hd:" HD-изображения",
        watermarks:"без водяных знаков можно скачать в настоящее время.",
        view_details:"Посмотреть детали",
        loading:"Загрузка…",
    },
    content:{
        failed:"Неуспешный",
        completed:"Завершенный",
        processing:"Обработка",
        img_processing:"Обработка…",
        img_failed:"Не удалось обработать",
        uploading:"Загрузка",
        img_uploading:"Загрузка…",
        wait_upoading:"Ожидание загрузки…",
        waiting:"Ожидающий",
        img_waiting:"Ожидающий…",
        empty:"Пустой",
        magnification:"Увеличение:",
        drop:"Или перетащите файл изображения сюда, чтобы масштабировать и улучшить!",
        original:"Оригинал:",
        output:"Выход:",
    },
    banner_msg:"Выберите план для масштабирования изображения",
    monthly:"ЕЖЕМЕСЯЧНО",
    lifetime:"ПРОДОЛЖИТЕЛЬНОСТЬ ЖИЗНИ",
    choose_plan:"Выберите свой план в зависимости от количества изображений",
    return_home:"Поздравляем! Вы успешно обновились. Пожалуйста, вернитесь на главную страницу и используйте этот продукт.",
    congratulations:"Поздравляем! Вы успешно обновились. Преимущества были привязаны к адресу электронной почты, который вы оставили при обновлении. Пожалуйста, используйте учетную запись, зарегистрированную или связанную с адресом электронной почты, чтобы",
    login_benefits:"авторизуйтесь для использования преимуществ",
    no_registered:". Если вы не зарегистрировались или не связали учетную запись с адресом электронной почты, пожалуйста,",
    register_account:"используйте адрес электронной почты для регистрации учетной записи",
    other_accounts:" или свяжите другие учетные записи с этим адресом электронной почты для использования преимуществ.",
    btn_close:"Закрывать",
    free:"Бесплатно",
    btn_get_started:"Начать",
    // access_to:"Доступ к",
    upscale_images:"Высококачественные изображения",
    up_to:"Вплоть до",
    per_image:" за изображение",
    resolution_of:"До разрешения",
    default_level:"Масштабирование изображений на уровне по умолчанию",
    image_downloads:"2 загрузки HD-изображений без водяных знаков",
    unlimited_image:"Неограниченное количество загрузок изображений с водяными знаками",
    SHA256_encryption:"Метод шифрования SHA256",
    mon:"Ежемесячно",
    images:"изображений",
    high_resolution:" с качеством высокого разрешения",
    tax_incl:"Вкл. налог.",
    image:"изображение",
    secure_checkout:"Безопасная оплата",
    everything:"Все бесплатно и",
    upscaling_levels:"Все уровни масштабирования могут быть выбраны",
    unlimited_image_without:"Неограниченное количество загрузок изображений без водяных знаков",
    viewable_editing:"Доступная для просмотра история редактирования действительна для",
    days:" дни",
    high_level:"Высокий уровень",
    priority_processing:" приоритетная обработка",
    left:"Продолжительность жизни",
    resolution:" разрешение",


    "history_will":"Истекает после",
    "history.days":"День (дни)",
    "history.hours":"часы",
    "expired":"Истекший",
    "access_to":"В бесплатной пробной версии вы можете только",
    "pricing.upload_images":"Загрузить изображения",
    "pricing.under":"под",
    "pricing.images":"изображений",
    "pricing.without_watermark":"без водяного знака",
    "pricing.process_images":"Обработка изображений до",
    "pricing.pixels":"пикселей",
    "pricing.enjoy_limited":"Наслаждайтесь ограниченными высококлассными оценками",
    "pricing.download":"Скачать",
    "pricing.HD_images":"HD-изображения без водяных знаков",
    "pricing.and_you":"И вы можете страдать от",
    "pricing.slow_upscaling":"медленное масштабирование",
    "pricing.lower_priority":"более низкий приоритет",
    "pricing.without":"без водяного маркера",
    "pricing.tax":"Налог включен в цену продажи и рассчитывается автоматически в зависимости от вашей страны и региона. В корзине вы можете увидеть подробную сумму налога. Ваша окончательная сумма платежа должна быть такой же, как отображаемая цена.",
    "pricing.you_can":"По подписке вы можете",
    "pricing.up_to":"Загружайте изображения до",
    "pricing.upscale_images":"Высококачественные изображения с",
    "pricing.no_watermark":"без водяного знака",
    "pricing.enhance":"Усиливать",
    "pricing.or_more":"изображения или больше",
    "pricing.in_batch":"в партии",
    "pricing.enlarge_images":"Увеличивайте изображения в",
    "pricing.and":"и",
    "pricing.times_with":"раз без ограничений",
    "pricing.enjoy":"Наслаждаться",
    "pricing.of_history":"времени хранения истории",
    "pricing.experience":"Опыт",
    "pricing.fast_upscaling":"быстрое масштабирование",
    "pricing.higher_priority":"более высокий приоритет",
    "pricing.early_access":"Ранний доступ к новым функциям",
    "pricing.cancel_anytime":"Отменить в любое время",
    "pricing.lifetime_license":"С пожизненной лицензией вы можете",
    "pricing.and_there":"И будет",
    "pricing.no_expiration":"нет срока годности",
    "pricing.unless":"если у вас не закончатся все апскейлы",
}